import { useQuery } from "@tanstack/react-query";
import { PropertyDto } from "@cma/shared/apis/comps/cma/generated";
import {
  convertFiltersSchemeToSidekickFindListingsV3,
  isModelEnoughToSearch,
  normalizeModel,
} from "../../chat-widgets/find-listings-search/helpers/search-comparable-form-model";
import { FindListingsSchema } from "../../chat-widgets/find-listings-search/helpers/property-search-filters-form-helpers";
import { extractQueryState } from "../helpers/extract-query-state";
import { getWidgetActionsApiClient } from "@shared/apis/sidekick/api-factories";
import { FindMapListingsResponse } from "@shared/apis/sidekick/generated";

const WIDGETS_FIND_MAP_LISTINGS_QUERY_KEY = "widgets-find-map-listings";
const CACHE_TIME_IN_MS = 1000 * 60 * 5; // 5 minutes

export const MAX_WIDGETS_FIND_MAP_LISTINGS_ITEMS = 200;

export const buildWidgetsFindMapListingsQueryKey = (
  state: FindListingsSchema,
) => {
  return [WIDGETS_FIND_MAP_LISTINGS_QUERY_KEY, normalizeModel(state)];
};

export function useWidgetsFindMapListings(props: {
  filtersState: FindListingsSchema;
  subjectProperty?: PropertyDto;
  onSuccess?: (data: FindMapListingsResponse) => void;
}) {
  const { filtersState, subjectProperty, onSuccess } = props;
  const api = getWidgetActionsApiClient();

  const query = useQuery({
    queryKey: buildWidgetsFindMapListingsQueryKey(filtersState),
    queryFn: async () => {
      const params = convertFiltersSchemeToSidekickFindListingsV3(
        filtersState,
        subjectProperty,
      );
      const response = await api.widgetsControllersSidekickFindMapListings({
        searchParamsMap: {
          ...params,
          paginationLimit: MAX_WIDGETS_FIND_MAP_LISTINGS_ITEMS,
          paginationPage: 1,
        },
      });
      onSuccess?.(response);
      return response;
    },
    enabled: isModelEnoughToSearch(filtersState),
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      const status = (error as any)?.response?.status || 0;
      if (failureCount < 3 && status === 429) {
        return true;
      }
      return false;
    },
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
}
